import { energyAnalysisApiSlice } from '../apiSlice';

export const energyDataApiSlice = energyAnalysisApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEnergyData: builder.query({
      query: (args) => {
        const {
          accountId,
          energyGroupId,
          start,
          end,
          activeHoursFilter,
          activeDaysFilter,
          activeHolidaysFilter,
        } = args;

        const params = new URLSearchParams({
          start_timestamp: new Date(start).toISOString(),
          end_timestamp: new Date(end + 1).toISOString(),
        });

        if (activeHoursFilter !== undefined) {
          params.append('active_hours_filter', activeHoursFilter.toString());
        }
        if (activeDaysFilter !== undefined) {
          params.append('active_days_filter', activeDaysFilter.toString());
        }
        if (activeHolidaysFilter !== undefined) {
          params.append('holidays_filter', activeHolidaysFilter.toString());
        }

        const url = `/energy_data/${accountId}/${energyGroupId}?${params.toString()}`;

        return { url };
      },
      providesTags: ['EnergyData'],
    }),
    getTimestampSummary: builder.query({
      query: (args) => {
        const { accountId, energyGroupId } = args;

        const url = `/energy_timestamps_summary/${accountId}/${energyGroupId}`;

        return { url };
      },
      providesTags: ['EnergyData'],
    }),

    getEnergyDataSpecific: builder.query({
      query: (args) => {
        const { accountId, energyGroupId, start, end, node_ids } = args;

        const params = new URLSearchParams();

        // Timestamps
        params.set('start_timestamp', new Date(start).toISOString());
        // If you need inclusive end on the server, keep +1 ms. If server treats end as exclusive, remove +1.
        params.set('end_timestamp', new Date(end + 1).toISOString());

        // node_ids as repeated params: &node_ids=a&node_ids=b
        if (Array.isArray(node_ids)) {
          node_ids
            .filter(Boolean)
            .forEach((id) => params.append('node_ids', id));
        } else if (typeof node_ids === 'string' && node_ids.trim()) {
          params.append('node_ids', node_ids.trim());
        }
        // else: omit node_ids when undefined/empty

        const url = `/energy_data_specific/${accountId}/${energyGroupId}?${params.toString()}`;
        return { url };
      },
      providesTags: ['EnergyData'],
    }),
  }),
});

export const {
  useGetEnergyDataQuery,
  useLazyGetEnergyDataQuery,
  useGetTimestampSummaryQuery,
  useGetEnergyDataSpecificQuery,
  useLazyGetEnergyDataSpecificQuery,
} = energyDataApiSlice;
